import api from '@/api';
import { API } from '@/api/constants';
import {
  CrmCustomerBaseRequest,
  CrmCustomerBirthdaysRequest,
  CrmCustomerCustomRequest,
  CrmCustomerDebitsListResponse,
  CrmCustomerFutureServiceListResponse,
  CrmCustomerFutureServicesRequest,
  CrmCustomerListResponse,
  CrmCustomerNextRevision,
  CrmCustomerRecoveryDebtsRequest,
  CrmCustomerWithMovimentRequest,
  CrmCustomerWithVehicleListResponse,
} from './CrmList.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API}crm-lists/v1`;

/**
 * CUSTOMERS
 */

export async function crmCustomerBirthdayList(
  params: CrmCustomerBirthdaysRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Customers/birthdays`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerListResponse>;
}

export async function crmCustomerSatisfactionSurveysList(
  params: CrmCustomerBaseRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Customers/satisfaction_surveys`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerListResponse>;
}

export async function crmCustomerWithMovimentList(
  params: CrmCustomerWithMovimentRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Customers/without_movement`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerListResponse>;
}

/**
 * INSTALLMENTS
 */

export async function crmCustomerRecoveryDebtsList(
  params: CrmCustomerRecoveryDebtsRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Installments/recovery_debts`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerDebitsListResponse>;
}

/**
 * VEHICLES
 */

export async function crmCustomerMarketingList(params: CrmCustomerBaseRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Vehicles/marketing`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerWithVehicleListResponse>;
}

export async function crmCustomerCustomList(params: CrmCustomerCustomRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Vehicles/custom`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerListResponse>;
}

export async function crmCustomerFutureServicesList(
  params: CrmCustomerFutureServicesRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Vehicles/future_services`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerFutureServiceListResponse>;
}

export async function crmCustomerNextRevisionsList(
  params: CrmCustomerCustomRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/Vehicles/next_revisions`,
    params,
  )) as unknown;

  return result as PageResult<CrmCustomerNextRevision>;
}
